import { render, staticRenderFns } from "./formTables.vue?vue&type=template&id=822a90a4&"
import script from "./formTables.vue?vue&type=script&lang=js&"
export * from "./formTables.vue?vue&type=script&lang=js&"
import style0 from "./formTables.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports